
export enum StaticVorlagenGruppen {
  Leer = 'Leer',
  Sonstiges = 'Sonstiges',
  TraegerReg = 'Traeger-Registrierung',
  AntragBE = 'Antrag-Betriebserlaubnis',
  Haupteinrichtung = 'Haupteinrichtung',
  Meldungen = 'Meldungen',
  Formblaetter = 'Formblätter',
  Ueberbelegung = 'Überbelegung',
  Untereinrichtung = 'Untereinrichtung',
}

export namespace StaticVorlagenGruppen {
  export function keys(): any[] {
    const values = Object.values(StaticVorlagenGruppen) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push({ id: i, name: values[i].replace('_', ' ') });
    }

    return results;
  }

  export function toNumber(grp: StaticVorlagenGruppen): number {
    const values = Object.values(StaticVorlagenGruppen) as string[];
    const results = [];
    for (let i = 0; i < values.length; i++) {
      if (values[i] === grp) {
        return i;
      }
    }

    return -1;
  }

  export function shortKey(eArt: StaticVorlagenGruppen): string {

    let result = '';
    const _eArt = StaticVorlagenGruppen[eArt];
    switch (_eArt) {
      case 'Traeger':
        result = 'Träger';
        break;
      case 'TraegerReg':
        result = 'Träger-Registrierung';
        break;
      case 'AntragBE':
        result = 'Antrag auf Betriebserlaubnis';
        break;
      case 'Formblaetter':
        result = 'Formblätter';
        break;
      case 'Ueberbelegung':
        result = 'Überbelegung';
        break;
      default:
        result = eArt.toString();
        break;
    }

    return result;
  }
}

//---------------------------

export enum StaticVorlagenUnterGruppen {
  Leer = 'Leer',
  Erstantrag = 'Erstantrag',
  Veraenderungsantrag = 'Veraenderungsantrag',
  Erweiterungsantrag = 'Erweiterungsantrag',
  MeldungenEoE = 'Meldung-EoE',
  Meldepflichten = 'Meldepflicht'
}

export namespace StaticVorlagenUnterGruppen {
  export function keys(): any[] {
    const values = Object.values(StaticVorlagenUnterGruppen) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push({ id: i, name: values[i].replace('_', ' ') });
    }

    return results;
  }

  export function toNumber(grp: StaticVorlagenUnterGruppen): number {
    const values = Object.values(StaticVorlagenUnterGruppen) as string[];
    const results = [];
    for (let i = 0; i < values.length; i++) {
      if (values[i] === grp) {
        return i;
      }
    }

    return -1;
  }

  export function shortKey(eArt: StaticVorlagenUnterGruppen): string {

    let result = '';
    const _eArt = StaticVorlagenUnterGruppen[eArt];
    switch (_eArt) {
      case 'Veraenderungsantrag':
        result = 'Veränderungsantrag';
        break;
      default:
        result = eArt.toString();
        break;
    }

    return result;
  }
}


//---------------------------
export enum StaticVorlagenType {
  Leer,

  Hilfe_Intern,
  Hilfe_Traeger,

  Datenschutzverordnung,
  Antwort_Benutzer_Passwortwiederherstellung,
  Email_Standard,

  Antwort_Traeger_Reg_Antrag,
  Akte_Traeger_Reg_Antrag,

  Antwort_Traeger_Reg_Bewilligung,
  Akte_Traeger_Reg_Bewilligung,

  Antwort_Traeger_Reg_Ablehnung,
  Akte_Traeger_Reg_Ablehnung,

  Betriebserlaubnis,

  //---------------

  AntragBe_Antwort_Eingang,
  AntragBe_Erstantrag_Deckblatt,
  AntragBe_Veraenderungsantrag_Deckblatt,
  AntragBe_Erweiterungsantrag_Deckblatt,

  AntragBe_Erhebungsbogen_Personal,
  AntragBe_Personalbogen_Personal,
  AntragBe_Personalbogen_Leitung,

  Unterschriftenblatt,

  //---------------

  Pdf,

  Stammblatt_HE_Angebot_Untereinrichtung,
  Stammblatt_HE_Personaldatenblatt,
  Stammblatt_HE_Besondere_Vorkommnisse,

  Akte_Meldungen_EoE,
  Akte_Melddeflicht_Traeger_Anschrift,
  Akte_Melddeflicht_Traeger_Kontakte,
  Akte_Melddeflicht_Einrichtung_Schliessung,
  Akte_Melddeflicht_Konzeption,
  Akte_Melddeflicht_Leitung,
  Akte_Melddeflicht_Betreuung,
  Email_Rund,

  //---------------

  Formblatt_Erhebungsbogen_Personal,
  Formblatt_Stellungnahme_Sozialamt,
  Formblatt_Stellungnahme_Jugendamt,
  Formblatt_Wirtschaftliche_Selbstauskunft,

  Ausnahme,
  Manuell_Traeger_Zugangsdaten,
  Selbstauskunft,
  Selbstauskunft_Unterschriftenblatt,

  Stammblatt_UE_Personenuebersicht,
}

export namespace StaticVorlagenType {
  export function keys(): any[] {
    const values = Object.values(StaticVorlagenType) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push({ id: i, name: values[i].replace('_', ' ') });
    }

    return results;
  }
}
